import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { ToastContainer } from "react-toastify";
import { Suspense, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import Footer from "./components/Footer";
import AutoLogout from "./components/AutoLogout";
import {
  PDFViewer,
  AuthenticationCard,
  MemberPDFViewer,
  Settings,
  preloadAllComponents,
} from "./utils/lazyComponents";
import "./i18n";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

// Loading fallback component
function LoadingFallback() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      flexDirection="column"
    >
      <CircularProgress size={40} style={{ color: "#6c0c46" }} />
      <Box mt={2} style={{ color: "#6c0c46", fontSize: "14px" }}>
        Loading...
      </Box>
    </Box>
  );
}

// eslint-disable-next-line react/prop-types
function App({ instance }) {
  // Preload components after initial render
  useEffect(() => {
    preloadAllComponents();
  }, []);

  return (
    <MsalProvider instance={instance}>
      <Router>
        <div className="app-container">
          {/* Toast container */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <AutoLogout />

          {/* Main Content */}
          <div className="main-content">
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/view-pdf" element={<PDFViewer />} />
                <Route path="/" element={<AuthenticationCard />} />
                <Route path="/member-pdf" element={<AuthenticationCard />} />
                <Route
                  path="/member-pdf/:patientHash"
                  element={<AuthenticationCard />}
                />
                <Route
                  path="/member-pdf-viewer"
                  element={<MemberPDFViewer />}
                />
                {process.env.REACT_APP_PAPERLESS_ENABLED === "true" && (
                  <Route path="/settings" element={<Settings />} />
                )}
              </Routes>
            </Suspense>
          </div>

          {/* Footer */}
          <Footer />
        </div>
      </Router>
    </MsalProvider>
  );
}

export default App;
